import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="manual-order-register"
export default class extends Controller {
  connect() {
    console.log("manualOrderRegisterController connected");
  }

  async call(event) {
    if (event.key !== "Enter") return;

    document
      .querySelectorAll("[name='order_ids\\[\\]']")
      .forEach((input) => input.remove());

    const code_in = event.target.value.split("\n").map((code) => {
      const trimmedCode = code.trim();
      return trimmedCode.startsWith("R") ? trimmedCode : `R${trimmedCode}`;
    });

    const params = new URLSearchParams();
    code_in.forEach((code) => params.append("q[code_in][]", code));

    const response = await fetch(`/orders/efu_search?${params.toString()}`, {
      method: "GET",
      headers: { Accept: "application/json" }
    });
    const orders = await response.json();

    {
      const form = document.querySelector("form");

      orders.reverse().forEach((order) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "order_ids[]";
        input.value = order.id;
        form.appendChild(input);
      });

      console.log(orders);

      const html = orders
        .map(
          (order) => `
            <tr class="text-center">
              <td>${order.code}</td>
              <td>${order.client?.name}</td>
              <td>${order.order_number}</td>
              <td>${order.product_code}</td>
              <td>${order.product_name}</td>
              <td class="text-end">${order.quantity}</td>
              <td class="text-end">${order.total_apiece?.toLocaleString()}</td>
              <td class="text-end">${order.total?.toLocaleString()}</td>
              <td>${order.delivered_at}</td>
            </tr>
          `
        )
        .join("");

      document.querySelector("tbody[name=orders]").innerHTML = html;
    }
  }
}
